import { Trans } from 'react-i18next';
import AlertMessage from '~/components/data-display/AlertMessage';
import Text from '~/components/typographies/Text';
import styles from './UserBankAccountBindingErrorsAlert.module.scss';

export const UserBankAccountBindingErrorsAlert = () => {
  return (
    <div className={styles.container}>
      <AlertMessage box type={'warning'} className={styles.alert} size="medium">
        <Text variant={'body2'} weight={'semibold'}>
          <Trans i18nKey="user_bank_account.onboarding.contact_admin.main" ns="accounts" />
          <Text variant={'body2'} weight={'regular'}>
            <Trans i18nKey="user_bank_account.onboarding.contact_admin.suffix" ns="accounts" />
          </Text>
        </Text>
      </AlertMessage>
    </div>
  );
};
